import { render, staticRenderFns } from "./CWchatHistory.vue?vue&type=template&id=96e75214&scoped=true&"
import script from "./CWchatHistory.vue?vue&type=script&lang=js&"
export * from "./CWchatHistory.vue?vue&type=script&lang=js&"
import style0 from "./CWchatHistory.vue?vue&type=style&index=0&id=96e75214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e75214",
  null
  
)

export default component.exports